export default {
  questionnaireFormLoadingState(state) {
    return state.questionnaireFormLoading;
  },
  questionnaireFormDataState(state, getters) {
    return getters.profileDetailsState.is_top20tech_source
      ? state.questionnaireFormDataCgp
      : state.questionnaireFormDataTop20tech;
  },
  questionnaireFormErrorsState(state) {
    return state.questionnaireFormErrors;
  },
  isQuestionnaireFilled(state, getters) {
    let requiredFields = getters.profileDetailsState.is_top20tech_source
      ? ['city_id', 'title', 'summary']
      : ['city_id', 'industry', 'job_title'];
    let optionsDependent = {
      job_title: getters.jobTitlesOptionsState && getters.jobTitlesOptionsState.length
    };

    for (let fieldName of requiredFields) {
      if (
        !getters.questionnaireFormDataState[fieldName] &&
        (!optionsDependent.hasOwnProperty(fieldName) || optionsDependent[fieldName])
      ) {
        return false;
      }
    }
    return true;
  }
};
